//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  AppMixin,
  CmsMetaMixin,
} from "~/node_modules/sitis-nuxt/lib/mixins/index";
import ArticleCard from "~/components/blog/ArticleCard.vue";
import Breadcrumbs from "~/components/page/PageBreadcrumbs";
import Pagination from "~/components/common/Pagination.vue";

export default {
  name: "Articles",
  data() {
    return {
      article: {},
      isLoading: true, // Загрузка списка статей
      breadcrumbs: [
        {path: "/", title: this.$t("breadcrumbs.homePage")},
        {path: this.$route.path, title: this.$t("breadcrumbs.blog")},
      ],
    };
  },
  head() {
    let meta = [
      {
        hid: "og:title",
        name: "og:title",
        property: "og:title",
        content: this.meta?.page?.title || "Articles",
      },
      {
        hid: "og:site_name",
        name: "og:site_name",
        property: "og:site_name",
        content: "GrizzlySMS",
      },
      {
        hid: "og:description",
        name: "og:description",
        property: "og:description",
        content: this.meta?.page?.description || "Articles",
      },
      {
        hid: "metadescription",
        name: "description",
        content: this.getDescription,
      },
      {
        hid: "apple-mobile-web-app-title",
        name: "apple-mobile-web-app-title",
        content: `apple-${this.meta?.page?.title || "Articles"} `,
      },
    ];

    return {
      title: this.getTitle,
      meta,
    };
  },
  mixins: [CmsMetaMixin, AppMixin],
  components: {
    ArticleCard,
    Breadcrumbs,
    Pagination,
  },

  async asyncData({$api, route}) {
    const query = route?.query?.page || "";

    const {data: articles, headers} = await $api.agent.transport
      .get(`articles${query ? `?page=${query}` : ""}?expand=category`)
      .catch((err) => {});

    const pagination = {
      page: Number(headers["x-pagination-current-page"]),
      perPage: Number(headers["x-pagination-per-page"]),
      pageCount: Number(headers["x-pagination-page-count"]),
      totalCount: Number(headers["x-pagination-total-count"]),
    };

    return {
      articles,
      pagination,
    };
  },

  computed: {
    getTitle() {
      const pageNumber = this?.pagination?.page || null;

      if (pageNumber >= 2) {
        return `${
          this?.meta?.page?.title_tag || this.appCfg?.siteName
        } - ${this.$t("blog.pageNumber")}${pageNumber}`;
      }
      return this?.meta?.page?.title_tag || this.appCfg?.siteName;
    },

    getDescription() {
      const pageNumber = this?.pagination?.page || null;

      if (pageNumber >= 2) {
        return `${this?.meta?.page?.description || "Articles"} - ${this.$t("blog.pageNumber")}${pageNumber}`;
      }
      return this?.meta?.page?.description || "Articles";
    },


    linkForPagination: function () {
      const current = this.$router?.currentRoute;

      let query = {...current.query};
      query.page = '$page';

      let link = [];
      Object.keys(query).map((t) => {
        link.push(`${t}=${query[t]}`);
      });
      link = link.filter((t) => !!t).join("&");

      return [current.path, link].filter((t) => !!t).join("?")
    },

    noArticlesMessage() {
      const locale = this.$i18n.localeProperties.code;
      if (locale === 'ru') {
        return 'Статей еще нет';
      }
      if (locale === 'en') {
        return 'No articles yet';
      }
      if (locale === 'cn') {
        return '还没有文章';
      }
      if (locale === 'tr') {
        return 'Henüz makale yok';
      }
    },

    setTitle: function () {},
    setDescription: function () {},
  },

  methods: {
    // Загрузка статей
    onLoadArticles: async function ({isResetArticles}) {
      const {query} = this.$route;

      this.isLoading = true;

      // текущий список статей
      let currentArticles = Boolean(isResetArticles) ? [] : [...this.articles];

      // Получение списка статей
      const {data: articles, headers} = await this.$api.agent.transport.get(
        `articles?page=${this.pagination.page}?expand=category`
      );

      // Устоновка пагинации по данным из API
      const newPagination = {
        page: Number(headers["x-pagination-current-page"]),
        perPage: Number(headers["x-pagination-per-page"]),
        pageCount: Number(headers["x-pagination-page-count"]),
        totalCount: Number(headers["x-pagination-total-count"]),
      };

      // Замена данных в url
      this.$router.replace({query: {page: newPagination.page}});

      // Замена или добавление статей
      this.articles = [...currentArticles, ...articles];
      this.pagination = newPagination;

      this.isLoading = false;
    },

    // Изменение пагинации (страницы, кол-во на странице и тд)
    onChangePagination: async function ({page, perPage, isResetArticles}) {
      let newPagination = {...this.pagination};

      newPagination["page"] = page || newPagination.page;
      newPagination["perPage"] = perPage || newPagination.perPage;

      this.pagination = newPagination;
      await this.onLoadArticles({isResetArticles});
    },
  },
};
